export const TWA_REFERRER = 'android-app://org.familysearch.www.together_twa'
const SESSION_KEY = 'is_twa_mode'
const LEGACY_LOCAL_KEY = 'is_twa_mode'
const hasTwaReferrer = () => {
  const referrer = document.referrer ?? ''
  return referrer === TWA_REFERRER || referrer.startsWith(`${TWA_REFERRER}/`)
}

/**
 * Whether we're running inside the Together Android app (TWA).
 *
 * `document.referrer` only carries the android-app value on the *first* document of a launch
 * so the first call that sees it records the answer in sessionStorage for the rest of the session.
 */
export default function getIsTWAMode() {
  if (typeof window === 'undefined') return false

  try {
    // One-time heal for browsers still carrying the leaked flag
    window.localStorage.removeItem(LEGACY_LOCAL_KEY)
  } catch {
    // ignore
  }

  try {
    if (window.sessionStorage.getItem(SESSION_KEY) === 'true') return true
  } catch {
    // sessionStorage access throws in some locked-down webviews; fall through to the referrer check.
  }

  if (!hasTwaReferrer()) return false

  try {
    window.sessionStorage.setItem(SESSION_KEY, 'true')
  } catch {
    // Nothing useful to do — we just re-derive from the referrer while it's still available.
  }
  return true
}

export const getTrackingMode = (isTWAMode, isPWAMode) => {
  let trackingMode
  if (isTWAMode) {
    trackingMode = 'TWA'
  } else if (isPWAMode) {
    trackingMode = 'PWA'
  } else {
    trackingMode = 'WEB'
  }
  return trackingMode
}
